/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/document-hitlist/components/document-hitlist.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../src/app/document-hitlist/services/document-hitlist-api.service';
import * as import6 from '../../../../../src/app/document-hitlist/services/document-hitlist-config.service';
import * as import7 from '../../../../../src/app/document-hitlist/services/mobile-detector.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '../../../../../src/app/shared/services/api.service';
import * as import12 from '../../../../../src/app/shared/services/config.service';
import * as import13 from '../../../../../src/app/shared/services/messenger.service';
import * as import14 from './document-hitlist.component.css.shim.ngstyle';
import * as import15 from 'ng2-translate/src/translate.pipe';
import * as import16 from '@angular/core/src/linker/view_container';
import * as import17 from '@angular/core/src/change_detection/change_detection_util';
import * as import18 from 'ng2-translate/src/translate.service';
import * as import19 from '../../../../../src/app/document-hitlist/components/document-hitlist-grid.component';
import * as import20 from './document-hitlist-grid.component.ngfactory';
import * as import21 from '@angular/core/src/zone/ng_zone';
import * as import22 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/common/src/directives/ng_if';
import * as import25 from '../../../../../src/app/shared/components/status.component';
import * as import26 from '../../shared/components/status.component.ngfactory';
import * as import27 from '../../../../../src/app/document-hitlist/components/document-view.component';
import * as import28 from './document-view.component.ngfactory';
export class Wrapper_DocumentHitlistComponent {
  /*private*/ _eventHandler:Function;
  context:import0.DocumentHitlistComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this._changed = false;
    this.context = new import0.DocumentHitlistComponent(p0,p1,p2,p3);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_DocumentHitlistComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_DocumentHitlistComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.DocumentHitlistComponent>;
  _DocumentHitlistApiService_0_3:import5.DocumentHitlistApiService;
  _DocumentHitlistConfigService_0_4:import6.DocumentHitlistConfigService;
  _MobileDetectorService_0_5:import7.MobileDetectorService;
  _DocumentHitlistComponent_0_6:Wrapper_DocumentHitlistComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocumentHitlistComponent_Host0,renderType_DocumentHitlistComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-document-hitlist',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_DocumentHitlistComponent0(this.viewUtils,this,0,this._el_0);
    this._DocumentHitlistApiService_0_3 = new import5.DocumentHitlistApiService(this.injectorGet(import11.ApiService,this.parentIndex));
    this._DocumentHitlistConfigService_0_4 = new import6.DocumentHitlistConfigService(this.injectorGet(import12.ConfigService,this.parentIndex));
    this._MobileDetectorService_0_5 = new import7.MobileDetectorService();
    this._DocumentHitlistComponent_0_6 = new Wrapper_DocumentHitlistComponent(this._DocumentHitlistApiService_0_3,this._DocumentHitlistConfigService_0_4,this.injectorGet(import13.MessengerService,this.parentIndex),this._MobileDetectorService_0_5);
    this.compView_0.create(this._DocumentHitlistComponent_0_6.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._DocumentHitlistComponent_0_6.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.DocumentHitlistApiService) && (0 === requestNodeIndex))) { return this._DocumentHitlistApiService_0_3; }
    if (((token === import6.DocumentHitlistConfigService) && (0 === requestNodeIndex))) { return this._DocumentHitlistConfigService_0_4; }
    if (((token === import7.MobileDetectorService) && (0 === requestNodeIndex))) { return this._MobileDetectorService_0_5; }
    if (((token === import0.DocumentHitlistComponent) && (0 === requestNodeIndex))) { return this._DocumentHitlistComponent_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DocumentHitlistComponent_0_6.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const DocumentHitlistComponentNgFactory:import10.ComponentFactory<import0.DocumentHitlistComponent> = new import10.ComponentFactory<import0.DocumentHitlistComponent>('obpa-document-hitlist',View_DocumentHitlistComponent_Host0,import0.DocumentHitlistComponent);
const styles_DocumentHitlistComponent:any[] = [import14.styles];
class View_DocumentHitlistComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_DocumentHitlistComponent2,renderType_DocumentHitlistComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import17.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','alert alert-warning','tabindex','0'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import17.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('QUERY LIMIT REACHED')),'\n        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_DocumentHitlistComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_DocumentHitlistComponent3,renderType_DocumentHitlistComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import17.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','alert alert-info','tabindex','0'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import17.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('NO DOCUMENTS FOUND')),'\n        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_DocumentHitlistComponent4 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import19.DocumentHitlistGridComponent>;
  _DocumentHitlistGridComponent_0_3:import20.Wrapper_DocumentHitlistGridComponent;
  _text_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_DocumentHitlistComponent4,renderType_DocumentHitlistComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'obpa-document-hitlist-grid',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import20.View_DocumentHitlistGridComponent0(this.viewUtils,this,0,this._el_0);
    this._DocumentHitlistGridComponent_0_3 = new import20.Wrapper_DocumentHitlistGridComponent(this.parentView.parentView.parentView.injectorGet(import21.NgZone,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import6.DocumentHitlistConfigService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import18.TranslateService,this.parentView.parentView.parentIndex));
    this._text_1 = this.renderer.createText((null as any),'\n        ',(null as any));
    this.compView_0.create(this._DocumentHitlistGridComponent_0_3.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray4(4,'documentOpen',(null as any),'documentOpenInNewWindow',(null as any)),this.eventHandler(this.handleEvent_0));
    this._DocumentHitlistGridComponent_0_3.subscribe(this,this.eventHandler(this.handleEvent_0),true,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.DocumentHitlistGridComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._DocumentHitlistGridComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.documentList.documents;
    this._DocumentHitlistGridComponent_0_3.check_documents(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this.parentView.parentView.context.documentList.displayColumns;
    this._DocumentHitlistGridComponent_0_3.check_columns(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = this.parentView.parentView.context.documentList.isFullText;
    this._DocumentHitlistGridComponent_0_3.check_isFullText(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = this.parentView.parentView.context.isMobileBrowser;
    this._DocumentHitlistGridComponent_0_3.check_isMobileBrowser(currVal_0_0_3,throwOnChange,false);
    if (this._DocumentHitlistGridComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange)) { this.compView_0.markAsCheckOnce(); }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._DocumentHitlistGridComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'documentOpen')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.onDocumentOpen($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'documentOpenInNewWindow')) {
      const pd_sub_1:any = ((<any>this.parentView.parentView.context.onDocumentOpenInNewWindow($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_DocumentHitlistComponent1 extends import1.AppView<any> {
  _text_0:any;
  _anchor_1:any;
  /*private*/ _vc_1:import16.ViewContainer;
  _TemplateRef_1_5:any;
  _NgIf_1_6:import22.Wrapper_NgIf;
  _text_2:any;
  _anchor_3:any;
  /*private*/ _vc_3:import16.ViewContainer;
  _TemplateRef_3_5:any;
  _NgIf_3_6:import22.Wrapper_NgIf;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import16.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import22.Wrapper_NgIf;
  _text_6:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_DocumentHitlistComponent1,renderType_DocumentHitlistComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n\n        ',(null as any));
    this._anchor_1 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_1 = new import16.ViewContainer(1,(null as any),this,this._anchor_1);
    this._TemplateRef_1_5 = new import23.TemplateRef_(this,1,this._anchor_1);
    this._NgIf_1_6 = new import22.Wrapper_NgIf(this._vc_1.vcRef,this._TemplateRef_1_5);
    this._text_2 = this.renderer.createText((null as any),'\n\n        ',(null as any));
    this._anchor_3 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_3 = new import16.ViewContainer(3,(null as any),this,this._anchor_3);
    this._TemplateRef_3_5 = new import23.TemplateRef_(this,3,this._anchor_3);
    this._NgIf_3_6 = new import22.Wrapper_NgIf(this._vc_3.vcRef,this._TemplateRef_3_5);
    this._text_4 = this.renderer.createText((null as any),'\n\n        ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_5 = new import16.ViewContainer(5,(null as any),this,this._anchor_5);
    this._TemplateRef_5_5 = new import23.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import22.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText((null as any),'\n\n    ',(null as any));
    this.init(this._text_6,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._anchor_1,
      this._text_2,
      this._anchor_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (1 === requestNodeIndex))) { return this._TemplateRef_1_5; }
    if (((token === import24.NgIf) && (1 === requestNodeIndex))) { return this._NgIf_1_6.context; }
    if (((token === import23.TemplateRef) && (3 === requestNodeIndex))) { return this._TemplateRef_3_5; }
    if (((token === import24.NgIf) && (3 === requestNodeIndex))) { return this._NgIf_3_6.context; }
    if (((token === import23.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import24.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1_0_0:any = this.parentView.context.documentList.isTruncated;
    this._NgIf_1_6.check_ngIf(currVal_1_0_0,throwOnChange,false);
    this._NgIf_1_6.ngDoCheck(this,this._anchor_1,throwOnChange);
    const currVal_3_0_0:any = (this.parentView.context.documentList.documents.length == 0);
    this._NgIf_3_6.check_ngIf(currVal_3_0_0,throwOnChange,false);
    this._NgIf_3_6.ngDoCheck(this,this._anchor_3,throwOnChange);
    const currVal_5_0_0:any = (this.parentView.context.documentList.documents.length > 0);
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_1.detectChangesInNestedViews(throwOnChange);
    this._vc_3.detectChangesInNestedViews(throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_1.destroyNestedViews();
    this._vc_3.destroyNestedViews();
    this._vc_5.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._vc_1.nativeElement,ctx);
    this._vc_1.visitNestedViewRootNodes(cb,ctx);
    cb(this._text_2,ctx);
    cb(this._vc_3.nativeElement,ctx);
    this._vc_3.visitNestedViewRootNodes(cb,ctx);
    cb(this._text_4,ctx);
    cb(this._vc_5.nativeElement,ctx);
    this._vc_5.visitNestedViewRootNodes(cb,ctx);
    cb(this._text_6,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 1)) { return new View_DocumentHitlistComponent2(this.viewUtils,this,1,this._anchor_1,this._vc_1); }
    if ((nodeIndex == 3)) { return new View_DocumentHitlistComponent3(this.viewUtils,this,3,this._anchor_3,this._vc_3); }
    if ((nodeIndex == 5)) { return new View_DocumentHitlistComponent4(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
}
var renderType_DocumentHitlistComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.Emulated,styles_DocumentHitlistComponent,{});
export class View_DocumentHitlistComponent0 extends import1.AppView<import0.DocumentHitlistComponent> {
  _el_0:any;
  compView_0:import1.AppView<import25.StatusComponent>;
  _StatusComponent_0_3:import26.Wrapper_StatusComponent;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import16.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import22.Wrapper_NgIf;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  compView_6:import1.AppView<import27.DocumentViewComponent>;
  _DocumentViewComponent_6_3:import28.Wrapper_DocumentViewComponent;
  _text_7:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_16:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocumentHitlistComponent0,renderType_DocumentHitlistComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_16 = import17.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'obpa-status',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import26.View_StatusComponent0(this.viewUtils,this,0,this._el_0);
    this._StatusComponent_0_3 = new import26.Wrapper_StatusComponent();
    this._text_1 = this.renderer.createText((null as any),'\n\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_2 = new import16.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import23.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import22.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText((null as any),'\n\n',(null as any));
    this.compView_0.create(this._StatusComponent_0_3.context);
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,parentRenderNode,'obpa-document-view',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_6 = new import28.View_DocumentViewComponent0(this.viewUtils,this,6,this._el_6);
    this._DocumentViewComponent_6_3 = new import28.Wrapper_DocumentViewComponent(this.parentView.injectorGet(import5.DocumentHitlistApiService,this.parentIndex),this.parentView.injectorGet(import6.DocumentHitlistConfigService,this.parentIndex));
    this.compView_6.create(this._DocumentViewComponent_6_3.context);
    this._text_7 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'retry',(null as any)),this.eventHandler(this.handleEvent_0));
    this._StatusComponent_0_3.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray4(4,'close',(null as any),'keydown','document'),this.eventHandler(this.handleEvent_6));
    this._DocumentViewComponent_6_3.subscribe(this,this.eventHandler(this.handleEvent_6),true);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import24.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import25.StatusComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._StatusComponent_0_3.context; }
    if (((token === import27.DocumentViewComponent) && (6 === requestNodeIndex))) { return this._DocumentViewComponent_6_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import17.ValueUnwrapper();
    const currVal_0_0_0:any = this.context.status;
    this._StatusComponent_0_3.check_status(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = true;
    this._StatusComponent_0_3.check_keepVisibleWhileLoading(currVal_0_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_0_0_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('ERROR: DOCUMENTS')),'');
    this._StatusComponent_0_3.check_error(currVal_0_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    this._StatusComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = this.context.documentList;
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_6_0_0:any = this.context.isMobileBrowser;
    this._DocumentViewComponent_6_3.check_isMobileBrowser(currVal_6_0_0,throwOnChange,false);
    const currVal_6_0_1:any = this.context.currentDocument;
    this._DocumentViewComponent_6_3.check_document(currVal_6_0_1,throwOnChange,false);
    this._DocumentViewComponent_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    const currVal_16:boolean = !this.context.currentDocument;
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementAttribute(this._el_6,'data-hidden',((currVal_16 == null)? (null as any): currVal_16.toString()));
      this._expr_16 = currVal_16;
    }
    this.compView_0.internalDetectChanges(throwOnChange);
    this.compView_6.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this.compView_0.destroy();
    this.compView_6.destroy();
    this._StatusComponent_0_3.ngOnDestroy();
    this._DocumentViewComponent_6_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 0) && (ngContentIndex == 0))) {
      cb(this._text_1,ctx);
      cb(this._vc_2.nativeElement,ctx);
      this._vc_2.visitNestedViewRootNodes(cb,ctx);
      cb(this._text_3,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_DocumentHitlistComponent1(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'retry')) {
      const pd_sub_0:any = ((<any>this.context.onRetry()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.compView_6.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DocumentViewComponent_6_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'close')) {
      const pd_sub_0:any = ((<any>this.context.onDocumentViewClose()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/document-hitlist/components/document-hitlist.component.ngfactory.ts